import { makeSceneObject } from '../three/ObjectManager'
import type { SceneObject } from '../types/scene'
import { deepClone } from './deepClone'

/**
 * 在指定世界坐标放置与 src 同配置的新对象（新 id，清除成组与资产编码绑定）。
 */
export function cloneSceneObjectAt(
  src: SceneObject,
  position: [number, number, number],
  name?: string
): SceneObject {
  const newObj = makeSceneObject(src.type, position)
  newObj.params = deepClone(src.params ?? {})
  if (newObj.params && typeof newObj.params === 'object' && 'assetCode' in newObj.params) {
    delete newObj.params.assetCode
  }
  newObj.name = name ?? src.name
  newObj.assetCode = undefined
  newObj.groupId = undefined
  newObj.floorId = src.floorId
  newObj.rotationY = src.rotationY ?? 0
  if (src.rotationX !== undefined) newObj.rotationX = src.rotationX
  if (src.rotationZ !== undefined) newObj.rotationZ = src.rotationZ
  if (src.label) newObj.label = deepClone(src.label)
  if (src.importedModel) newObj.importedModel = deepClone(src.importedModel)
  if (src.materialOverrides) newObj.materialOverrides = deepClone(src.materialOverrides)
  if (src.hiddenMeshes) newObj.hiddenMeshes = [...src.hiddenMeshes]
  newObj.locked = src.locked
  newObj.hidden = src.hidden
  if (src.infoCard) newObj.infoCard = deepClone(src.infoCard)
  if (src.statusLight) newObj.statusLight = deepClone(src.statusLight)
  if (src.dataBindings) {
    newObj.dataBindings = deepClone(src.dataBindings)
  }
  // 路径引用字段：克隆保留同一路径绑定，用户可在属性面板按需调整 offset
  if (src.pathId != null) newObj.pathId = src.pathId
  if (src.pathOffset !== undefined) newObj.pathOffset = src.pathOffset
  if (src.direction !== undefined) newObj.direction = src.direction
  if (src.loop !== undefined) newObj.loop = src.loop
  return newObj
}
